import { resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-cdec6b92")

_pushScopeId("data-v-cdec6b92")
const _hoisted_1 = { class: "chatMessage left moreMargin" }
const _hoisted_2 = { class: "fs-13 greyBlue d-block" }
const _hoisted_3 = { class: "timestamp" }
const _hoisted_4 = { class: "commentFooter" }
const _hoisted_5 = {
  key: 0,
  class: "me-3"
}
const _hoisted_6 = { class: "fs_12 grey me-1" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _directive_userimage = _resolveDirective("userimage")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _withDirectives(_createVNode("div", {
        class: "chatImg",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openPerson(_ctx.comment.createdBy)))
      }, null, 512), [
        [_directive_userimage, _ctx.$store.state.getUserImage(_ctx.comment.createdBy.identifier)]
      ]),
      _createVNode("span", _hoisted_2, _toDisplayString(_ctx.comment.createdBy.name), 1),
      _createVNode("span", {
        innerHTML: _ctx.comment.text
      }, null, 8, ["innerHTML"]),
      _createVNode("small", _hoisted_3, _toDisplayString(_ctx.$filters.date(_ctx.comment.createdOn, "ddd DD MMM hh:mm")), 1)
    ]),
    _createVNode("div", _hoisted_4, [
      (_ctx.comment.replyCount)
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            _createVNode("span", _hoisted_6, _toDisplayString(_ctx.comment.replyCount), 1),
            _createVNode(_component_localized_text, {
              class: "fs_12 grey",
              localizedKey: "app_risposte",
              text: "risposte"
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.showReplyButton && _ctx.comment.replyCount > 0)
        ? (_openBlock(), _createBlock("div", {
            key: 1,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.reply()))
          }, [
            _createVNode(_component_localized_text, {
              class: "fs_12 grey",
              localizedKey: 'app_vedirispondi',
              text: 'Vedi / Rispondi'
            })
          ]))
        : (_ctx.showReplyButton && _ctx.comment.replyCount == 0)
          ? (_openBlock(), _createBlock("div", {
              key: 2,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.reply()))
            }, [
              _createVNode(_component_localized_text, {
                class: "fs_12 grey",
                localizedKey: 'app_rispondi',
                text: 'Rispondi'
              })
            ]))
          : _createCommentVNode("", true),
      (_ctx.canDeleteComment)
        ? (_openBlock(), _createBlock("div", {
            key: 3,
            class: _ctx.showReplyButton ? 'ms-3' : '',
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.deleteComment()))
          }, [
            _createVNode(_component_localized_text, {
              class: "fs_12 grey",
              localizedKey: 'app_elimina',
              text: 'Elimina'
            })
          ], 2))
        : _createCommentVNode("", true),
      (!_ctx.canDeleteComment)
        ? (_openBlock(), _createBlock("div", {
            key: 4,
            class: _ctx.showReplyButton ? 'ms-3' : '',
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.reportComment()))
          }, [
            _createVNode(_component_localized_text, {
              class: "fs_12 grey",
              localizedKey: 'app_segnala',
              text: 'Segnala'
            })
          ], 2))
        : _createCommentVNode("", true)
    ])
  ], 64))
})